var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5C7 16.5 13 11.2826 13 7.36957C13 4.12789 10.3137 1.5 7 1.5C3.68629 1.5 1 4.12789 1 7.36957C1 11.2826 7 16.5 7 16.5Z",
    stroke: "#F58634",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91691 7.12512C8.91691 8.16065 8.05879 9.00012 7.00025 9.00012C5.9417 9.00012 5.08358 8.16065 5.08358 7.12512C5.08358 6.08959 5.9417 5.25012 7.00025 5.25012C8.05879 5.25012 8.91691 6.08959 8.91691 7.12512Z",
    stroke: "#F58634",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.2f216310ec0087658d4e123cf031e374.svg";
export { ForwardRef as ReactComponent };